import { componentStateStore } from '@mfe/store';
import { customElement } from 'lit/decorators.js';

import { TefComsCancelButton } from './TefComsCancelButton';

@customElement('tef-coms-back-button')
export class TefComsBackButton extends TefComsCancelButton {
  handleClick() {
    componentStateStore.disabled = true;

    this.triggerEvent({
      name: 'action/CANCEL_MICROFRONTEND',
      level: 'info',
      message: 'cancel action invoked',
    });
  }
}
